import { createSlice } from "@reduxjs/toolkit";
import { fetchEmbeds, fetchMedia } from "../action/embedActions";

const initialState = {
  isLoading: false,
  embedList: [],
  mediaList: [],
};

export const embedSlice = createSlice({
  name: "Embed",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch-embeds
    builder.addCase(fetchEmbeds.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchEmbeds.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      const groupedData = data?.reduce((acc, item) => {
        if (!acc[item?.menu_type]) {
          acc[item?.menu_type] = [];
        }
        acc[item?.menu_type].push(item);
        return acc;
      }, {});
      console.log(groupedData)
      state.embedList = groupedData ?? {};
      state.isLoading = false;
    });
    builder.addCase(fetchEmbeds.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-media
    builder.addCase(fetchMedia.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMedia.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.mediaList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchMedia.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default embedSlice.reducer;
